import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";

const LOGO_URL =
  "/assets/logo.png";

const ARTICLES = [
  {
    n: "1",
    title: "Objet",
    body: (
      <>
        <p>
          Les présentes Conditions Générales de Vente (ci-après «&nbsp;CGV&nbsp;»)
          régissent l&apos;ensemble des relations contractuelles entre{" "}
          <strong>LeGuidedesEntrepreneurs.fr</strong> (ci-après «&nbsp;l&apos;Éditeur&nbsp;»)
          et toute personne physique ou morale (ci-après «&nbsp;le Client&nbsp;»)
          souscrivant à l&apos;offre de création de page web professionnelle
          commercialisée sur le site LeGuidedesEntrepreneurs.fr.
        </p>
      </>
    ),
  },
  {
    n: "2",
    title: "Description du service",
    body: (
      <>
        <p>
          L&apos;Éditeur propose la création, l&apos;hébergement et la mise à
          disposition d&apos;une page web professionnelle personnalisable,
          accessible via une URL dédiée (de type{" "}
          <em>LeGuidedesEntrepreneurs.fr/entreprise/nom-de-votre-entreprise</em>).
          Le service inclut&nbsp;:
        </p>
        <ul>
          <li>1 page internet professionnelle pour votre entreprise.</li>
          <li>Accès à notre plateforme pendant toute la durée de l&apos;abonnement.</li>
          <li>
            Accès à un espace client de personnalisation (textes, photos,
            couleurs, témoignages, services, réseaux sociaux).
          </li>
          <li>
            L&apos;hébergement sécurisé en HTTPS en
            (LeGuidedesEntrepreneurs.fr/entreprise/nom-de-votre-entreprise).
          </li>
          <li>Mise en ligne et SEO Google.</li>
        </ul>
      </>
    ),
  },
  {
    n: "3",
    title: "Tarif et modalités de paiement",
    body: (
      <>
        <p>
          Le service est proposé sous forme d&apos;<strong>abonnement mensuel de
          9,90&nbsp;€ TTC par mois</strong>, sans engagement de durée et sans
          frais cachés.
        </p>
        <p>
          Le paiement est prélevé automatiquement chaque mois par carte
          bancaire, via le prestataire de paiement sécurisé{" "}
          <strong>Stripe</strong>. Aucune information bancaire n&apos;est
          conservée par l&apos;Éditeur. Le Client peut résilier à tout moment
          depuis son espace client (onglet « Abonnement »), sans pénalité :
          l&apos;abonnement prend fin à l&apos;échéance de la période en cours
          et la page entreprise est alors dépubliée.
        </p>
      </>
    ),
  },
  {
    n: "4",
    title: "Commande et activation",
    body: (
      <p>
        La commande est validée dès la confirmation du paiement par Stripe. Le
        Client reçoit alors un accès à son espace client lui permettant de
        personnaliser sa page. La page est rendue publique une fois la
        personnalisation finalisée par le Client.
      </p>
    ),
  },
  {
    n: "5",
    title: "Droit de rétractation",
    body: (
      <p>
        Conformément à l&apos;article L221-28 du Code de la consommation, le
        service de création de page web étant entièrement personnalisé et
        exécuté immédiatement après le paiement, le Client renonce
        expressément à son droit de rétractation dès le démarrage de la
        personnalisation.
      </p>
    ),
  },
  {
    n: "6",
    title: "Obligations du Client",
    body: (
      <p>
        Le Client s&apos;engage à fournir des informations exactes et licites
        lors de la personnalisation de sa page. Il est seul responsable du
        contenu publié (textes, images, mentions commerciales). Tout contenu
        illégal, diffamatoire, contrefaisant ou portant atteinte aux droits de
        tiers est strictement prohibé et pourra entraîner la suspension
        immédiate de la page sans remboursement.
      </p>
    ),
  },
  {
    n: "7",
    title: "Propriété intellectuelle",
    body: (
      <p>
        Les modèles graphiques, le code source et l&apos;ensemble des éléments
        du site LeGuidedesEntrepreneurs.fr demeurent la propriété exclusive de
        l&apos;Éditeur. Le Client conserve la pleine propriété des contenus
        qu&apos;il publie (textes, photos, logo).
      </p>
    ),
  },
  {
    n: "8",
    title: "Disponibilité du service",
    body: (
      <p>
        L&apos;Éditeur met en œuvre tous les moyens raisonnables pour garantir
        une disponibilité permanente du service. Toutefois, il ne saurait être
        tenu responsable des interruptions liées à la maintenance, à des
        incidents techniques ou à un cas de force majeure.
      </p>
    ),
  },
  {
    n: "9",
    title: "Données personnelles",
    body: (
      <p>
        Le traitement des données personnelles est détaillé dans les Mentions
        Légales. Le Client dispose à tout moment d&apos;un droit d&apos;accès,
        de rectification et de suppression de ses données.
      </p>
    ),
  },
  {
    n: "10",
    title: "Responsabilité",
    body: (
      <p>
        La responsabilité de l&apos;Éditeur ne pourra excéder le montant payé
        par le Client au titre de la commande concernée. L&apos;Éditeur ne
        saurait être tenu responsable des pertes indirectes (manque à gagner,
        perte de clientèle, etc.).
      </p>
    ),
  },
  {
    n: "11",
    title: "Loi applicable et litiges",
    body: (
      <p>
        Les présentes CGV sont régies par le droit français. Tout litige
        relatif à leur interprétation ou à leur exécution sera soumis, à défaut
        d&apos;accord amiable, aux tribunaux compétents.
      </p>
    ),
  },
];

export default function Cgv() {
  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="cgv-page">
      {/* Header */}
      <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Le Guide des Entrepreneurs" className="h-8 w-auto sm:h-10" />
          </Link>
          <Link
            to="/"
            data-testid="cgv-back-home"
            className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-[10px] font-semibold text-[#1E2A5E] transition-colors hover:border-[#2FA398] hover:text-[#2FA398] sm:px-4 sm:py-2 sm:text-xs"
          >
            <ArrowLeft className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
            Retour à l&apos;accueil
          </Link>
        </div>
      </header>

      {/* Hero */}
      <section className="border-b border-slate-100 bg-gradient-to-b from-white to-slate-50">
        <div className="mx-auto max-w-4xl px-4 py-8 text-center sm:px-6 sm:py-12 lg:py-16 lg:px-8">
          <div className="mx-auto mb-4 flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-[#1E2A5E] to-[#2FA398] shadow-lg shadow-[#1E2A5E]/20 sm:mb-5 sm:h-14 sm:w-14">
            <FileText className="h-5 w-5 text-white sm:h-7 sm:w-7" strokeWidth={2} />
          </div>
          <span className="inline-block rounded-full border border-[#2FA398]/30 bg-white px-3 py-1 font-mono text-[9px] font-bold uppercase tracking-widest text-[#2FA398] sm:px-4 sm:py-1.5 sm:text-[10px]">
            Informations légales
          </span>
          <h1
            data-testid="cgv-title"
            className="mt-3 text-2xl font-extrabold leading-tight tracking-tight text-[#1E2A5E] sm:mt-4 sm:text-3xl lg:text-5xl"
          >
            Conditions Générales de Vente
          </h1>
          <p className="mx-auto mt-3 max-w-2xl text-xs leading-relaxed text-slate-600 sm:mt-4 sm:text-sm lg:text-base">
            Ces conditions générales de vente régissent votre commande sur{" "}
            <span className="font-semibold text-[#1E2A5E]">
              LeGuidedesEntrepreneurs.fr
            </span>
            . Merci de les lire attentivement avant tout paiement.
          </p>
        </div>
      </section>

      {/* Content */}
      <main className="mx-auto max-w-4xl px-4 py-8 sm:px-6 sm:py-12 lg:py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-5 sm:gap-8">
          {ARTICLES.map(({ n, title, body }) => (
            <article
              key={n}
              id={`article-${n}`}
              data-testid={`cgv-article-${n}`}
              className="relative rounded-2xl border border-slate-200 bg-white p-5 shadow-[0_4px_20px_-4px_rgba(30,42,94,0.06)] transition-shadow hover:shadow-[0_12px_30px_-12px_rgba(30,42,94,0.14)] sm:p-6 lg:p-8"
            >
              <span className="absolute inset-y-4 left-0 w-1 rounded-full bg-gradient-to-b from-[#1E2A5E] to-[#2FA398]" />
              <header className="mb-3 flex items-start gap-3 sm:mb-4 sm:gap-4">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#1E2A5E] font-mono text-xs font-bold text-white shadow-sm sm:h-10 sm:w-10 sm:rounded-xl sm:text-sm">
                  {n}
                </span>
                <h2 className="pt-1 text-base font-extrabold leading-tight text-[#1E2A5E] sm:pt-1.5 sm:text-lg lg:text-xl">
                  {title}
                </h2>
              </header>
              <div className="prose prose-slate max-w-none space-y-2.5 text-[13px] leading-relaxed text-slate-700 sm:space-y-3 sm:text-sm lg:text-[15px] [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1.5 [&_li]:marker:text-[#2FA398] [&_strong]:text-[#1E2A5E] [&_em]:text-slate-800">
                {body}
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 flex justify-center sm:mt-12">
          <Link
            to="/"
            data-testid="cgv-back-home-bottom"
            className="inline-flex items-center gap-2 rounded-full bg-[#1E2A5E] px-5 py-2.5 text-xs font-bold text-white shadow-sm transition-colors hover:bg-[#2A3B7A] sm:px-6 sm:py-3 sm:text-sm"
          >
            <ArrowLeft className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
            Retour à l&apos;accueil
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 bg-white">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-4 py-5 text-center sm:flex-row sm:text-left sm:px-6 sm:py-6 lg:px-8">
          <img src={LOGO_URL} alt="Le Guide des Entrepreneurs" className="h-7 w-auto sm:h-9" />
          <p className="text-[10px] text-slate-500 sm:text-[11px]">
            © {new Date().getFullYear()}{" "}
            <a
              href="https://leguidedesentrepreneurs.fr/"
              className="font-semibold text-[#1E2A5E] hover:text-[#2FA398]"
              target="_blank"
              rel="noopener noreferrer"
            >
              Le Guide des Entrepreneurs.fr
            </a>{" "}
            — Tous droits réservés.
          </p>
        </div>
      </footer>
    </div>
  );
}
